import { render } from "./schedule.vue?vue&type=template&id=2d34804e"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"

import "./schedule.vue?vue&type=style&index=0&id=2d34804e&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/schedule.vue'],['render',render],['__file',"schedule.vue"]])

export default __exports__